export default __webpack_public_path__ + "static/realWorldImage3-b451a1cba9194ab070f11e38f45765de.png";